/**
 * @generated SignedSource<<e20c99b4c91c5729aec1da4e3dde5e49>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserSelectionStepGetIncludesString$data = {
  readonly fullName: string;
  readonly internalAttributes: {
    readonly allReports: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly fullName: string;
        };
      }>;
    } | null;
  } | null;
  readonly " $fragmentType": "UserSelectionStepGetIncludesString";
};
export type UserSelectionStepGetIncludesString$key = {
  readonly " $data"?: UserSelectionStepGetIncludesString$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserSelectionStepGetIncludesString">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserSelectionStepGetIncludesString",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "UserInternalAttributes",
      "kind": "LinkedField",
      "name": "internalAttributes",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserConnection",
          "kind": "LinkedField",
          "name": "allReports",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "UserEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "User",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "ddcf5e6d709062c1a9522e716ee4b9f1";

export default node;
